import { signOut, useAuthStore } from 'store/auth.store'
import axios from 'axios'

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
})

http.interceptors.request.use(request => {
  if (!request.headers) {
    request.headers = {}
  }
  request.headers['Accept'] = 'application/json'
  const { token } = useAuthStore.getState()
  if (token) {
    request.headers.Authorization = `Bearer ${token}`
  }
  return request
})

http.interceptors.response.use(
  response => response,
  error => {
    const isLoginEndpoint = error.config?.url && error.config.url.includes('login')
    if (error.response && error.response.status === 401 && !isLoginEndpoint) {
      signOut()
    }
    return Promise.reject(error)
  },
)


const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/+$/, '')

const cleanUrl = (url) => {
  if (typeof url !== 'string') return url
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  return `${API_URL}/${url.replace(/^\/+/, '')}`
}

export async function getRequest (url, config) {
  return http.get(cleanUrl(url), config).then(response => response.data)
}
export async function postRequest (url, data, config) {
  return http.post(cleanUrl(url), data, config).then(response => response.data)
}
export async function putRequest (url, data, config) {
  return http.put(cleanUrl(url), data, config).then(response => response.data)
}
export async function patchRequest (url, data, config) {
  return http.patch(cleanUrl(url), data, config).then(response => response.data)
}
export async function deleteRequest (url, config) {
  return http.delete(cleanUrl(url), config).then(response => response.data)
}

export async function downloadFile (url, filename) {
  const response = await http.get(cleanUrl(url), { responseType: 'blob' })
  const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename || 'document.pdf'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(link.href)
}

